import { create } from 'zustand';

interface CartItem {
  id: number;
  titulo: string;
  categoria: string;
  precio: number;
  cantidad: number;
  stock: number;
}

interface CartStore {
  items: CartItem[];
  count: number;
  addToCart: (producto: CartItem, cantidad: number) => void;
  removeItem: (id: number) => void;
  updateItemQuantity: (id: number, cantidad: number) => void;
  clearCart: () => void;
}

const useCartStore = create<CartStore>((set) => ({
  items: localStorage.getItem('carrito') ? JSON.parse(localStorage.getItem('carrito')!) : [],
  count: localStorage.getItem('carrito') 
    ? JSON.parse(localStorage.getItem('carrito')!).reduce((acc: number, item: CartItem) => acc + item.cantidad, 0)
    : 0,

    addToCart: (producto, cantidad) => {
        const carrito = localStorage.getItem('carrito') 
          ? JSON.parse(localStorage.getItem('carrito')!)
          : [];
        
        const productoExistente = carrito.find((item: CartItem) => item.id === producto.id);
        let nuevoCarrito = [...carrito];
        let nuevaCantidadTotal = useCartStore.getState().count;
    
        if (productoExistente) {
          const nuevaCantidad = productoExistente.cantidad + cantidad;
          if (nuevaCantidad > producto.stock) {
            throw new Error(`No puedes agregar más de ${producto.stock} unidades de ${producto.titulo}.`);
          }
          nuevoCarrito = nuevoCarrito.map(item =>
            item.id === producto.id ? { ...item, cantidad: nuevaCantidad } : item
          );
          nuevaCantidadTotal += cantidad;
        } else {
          if (cantidad > producto.stock) {
            throw new Error(`No puedes agregar más de ${producto.stock} unidades de ${producto.titulo}.`);
          }
          nuevoCarrito.push({ ...producto, cantidad });
          nuevaCantidadTotal += cantidad;
        }
    
        localStorage.setItem('carrito', JSON.stringify(nuevoCarrito));
        
        set({
          items: nuevoCarrito,
          count: nuevaCantidadTotal
        });
      }
  ,
  removeItem: (id) => {
    set((state) => {
      const newItems = state.items.filter((item) => item.id !== id);
      localStorage.setItem('carrito', JSON.stringify(newItems));
      return {
        items: newItems,
        count: newItems.reduce((acc, item) => acc + item.cantidad, 0)
      };
    });
  },

  updateItemQuantity: (id, cantidad) => {
    set((state) => {
      const newItems = state.items.map((item) =>
        item.id === id ? { ...item, cantidad } : item
      );
      localStorage.setItem('carrito', JSON.stringify(newItems));
      return {
        items: newItems,
        count: newItems.reduce((acc, item) => acc + item.cantidad, 0)
      };
    });
  },

  clearCart: () => {
    localStorage.removeItem('carrito');
    set({ items: [], count: 0 });
  }
}));

export default useCartStore;